import { render, staticRenderFns } from "./AgreementsOverview.vue?vue&type=template&id=cd847034&"
import script from "./AgreementsOverview.vue?vue&type=script&lang=js&"
export * from "./AgreementsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports